import "./global.css";
import "rc-slider/assets/index.css";

import Layout from "@/components/layouts/layout";
import { Fragment, useEffect } from "react";
import { CustomerContextProvider } from "@/stores/customer-context";
import { QueryParamsMiddleWare } from "middlewares/queryParamsMiddleware";
import { SWRConfig } from "swr";
import ErrorBoundaryFallBack, { logErrorHandler } from "@/components/error/error_boundary";
import { ErrorBoundary } from "react-error-boundary";
import { useErrorHandler } from "react-error-boundary";
import Script from "next/script";
import TagManager from "react-gtm-module/dist/TagManager";
import * as Sentry from "@sentry/nextjs";
import Head from "next/head";
import JwtAuthMiddleware from "@/middlewares/jwtAuthMiddleware";
import LayoutWithoutNavigation from "@/components/layouts/layout-without-navigation";
import { ApolloProvider } from "@apollo/client";
import { client } from "graphql/client";
import { AlertProvider } from "@/stores/alert-context";
import AlertSnackbar from "@/components/UI/alert-snackbar/alert_snackbar";
import ModalError from "@/components/UI/modal-error/modal_error";

export default function MyApp({ Component, pageProps, router }) {
  const isAfiliateLayout = router.query["affiliate"] || router.route.startsWith("/affiliate") ? true : false;
  const getLayout = isAfiliateLayout
    ? (page) => <LayoutWithoutNavigation children={page} />
    : (page) => <Layout children={page} />;
  const apiHost = { apiHost: process.env.API_HOST };
  const gtm = process.env.GTM_ID;
  const errorHandler = useErrorHandler();
  useEffect(() => {
    window.onerror = (msg, url, lineNo, columnNo, error) => {
      console.log("detected from onerror", error);
      return true;
    };
    TagManager.initialize({ gtmId: gtm });
  }, []);
  return (
    <ApolloProvider client={client}>
      <Head></Head>
      <ErrorBoundary FallbackComponent={ErrorBoundaryFallBack} onError={logErrorHandler}>
        <SWRConfig value={apiHost}>
          <CustomerContextProvider>
            <AlertProvider>
              <AlertSnackbar />
              <ModalError />
              <QueryParamsMiddleWare>{getLayout(<Component {...pageProps} />)}</QueryParamsMiddleWare>
            </AlertProvider>
          </CustomerContextProvider>
        </SWRConfig>
      </ErrorBoundary>
    </ApolloProvider>
  );
}
